const initialState = {
    showModal: true,
};

export default function QRReducers(state = initialState, { type, payload }) {
    switch (type) {
        case "QR_MODAL_SHOW":
            return {
                ...state,
                showModal: payload,
            };

        default:
            return { ...state };
    }
}
